module.exports = __webpack_public_path__ + "img/maximize.f7c1938e.svg";